import React from "react";
import { Card, Button, Divider } from "antd";
import { FaMapMarkerAlt  } from "react-icons/fa";
import LeaveDetails from "views/console/team-managements/components/LeaveDetails";
import OvertimeDetails from "views/console/team-managements/components/OvertimeDetails";
import { CircleCheck, CircleX } from "lucide-react";


const ApprovalCard = (props) => {

  const { name, location, leaveType, fromDate, toDate, days, reason, category, otHours, dateRequested, children } = props;
  return (


  <Card className="rounded-2xl border-2 border-orange-200 hover:border-orange-300 hover:shadow-lg overflow-y-auto space-y-4 pr-2 mb-2 hover:shadow-l">        
    <div className="flex justify-between items-start ">
      <span className="absolute items-center right-5 text-xs status-indicator draft">
          {category}
      </span>
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 font-semibold">
            {(name ? name.split(" ").map((n) => n[0]).join("") : "")}
        </div>
        <div>
          <h3 className="font-semibold text-gray-800">{name}</h3>
          <div className="flex items-center text-gray-600 text-sm">
            <FaMapMarkerAlt className="mr-1 text-gray-400" />
            {location}
          </div>
        </div>
      </div>
    </div>

  <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />
  
  {category === "Leave" ?
    <LeaveDetails
				{...props}
			/>
  : 
    <OvertimeDetails
				{...props}
    />

  }
      
      <div className="grid grid-cols-2 gap-2">
        <Button
          icon={<CircleX size={16}/>}
          block
          type="default"
          className="w-full mt-2 btn-reject"
        >
          Reject
        </Button>
        <Button
          icon={<CircleCheck size={16}/>}
          block
          type="default"
          className="w-full mt-2 btn-approve"
        >
          Approve
        </Button>

      </div>

  </Card>

  );
};

export default ApprovalCard;

